<template>
  <div v-if="isLoading" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Loading">Loading...
  </div>
  <div v-else>
    <TageList :tageList="this.$store.state.tags"></TageList>
    <div style="display: flex; justify-content: center;">
      <div>
        <Section :imageData="this.$store.state.imageInfos" illust_title="推荐作品"></Section>
        <Section :imageData="imageInfos_new" illust_title="新作品"></Section>
        <Section :imageData="imageInfos_rank" illust_title="榜单"></Section>
        <Section :imageData="imageInfos_hot" illust_title="热门"></Section>
      </div>
    </div>
  </div>

  <!-- <div>footer</div> -->
</template>
<script>
import { ref } from 'vue'
import TageList from '@/components/TageList.vue';
import Section from '@/components/Section copy.vue';
import paginater from '@/components/paginater.vue';

export default {
  name: 'HomeView',
  data() {
    return {
      isLoading: true,
      fullscreenLoading: ref(true),
      tags: [],
      imageInfos: this.$store.state.imageInfos,
      imageInfos_new: this.$store.state.imageInfos,
      imageInfos_rank: this.$store.state.imageInfos,
      imageInfos_hot: this.$store.state.imageInfos,

    }
  },

  async created() {
    try {
      await this.$axios.get("https://www.vilipix.com/api/v1/search/recommand_tag").then(res => {
        this.$store.state.tags = res.data.data.rows;
      }).catch(error => {
        console.log(error);
      })

      await this.$axios.get("https://www.vilipix.com/api/v1/picture/recommand?limit=20&offset=48").then(res => {
        this.$store.state.imageInfos = res.data.data.rows
      }).catch(error => {
        console.log(error);
      })

      await this.$axios.get("https://www.vilipix.com/api/v1/picture/public?limit=20&offset=0&sort=new&limit=20&offset=0").then(res => {
        this.imageInfos_new = res.data.data.rows
      }).catch(error => {
        console.log(error);
      })

      await this.$axios.get("https://www.vilipix.com/api/v1/picture/ranking?limit=20&offset=0&type=0").then(res => {
        this.imageInfos_rank = res.data.data.rows
      }).catch(error => {
        console.log(error);
      })

      await this.$axios.get("https://www.vilipix.com/api/v1/picture/public?limit=20&offset=3&sort=hot&type=0").then(res => {
        this.imageInfos_hot = res.data.data.rows
      }).catch(error => {
        console.log(error);
      })
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      this.isLoading = false;
    }
  },
  components: {
    TageList,
    Section,
    paginater,
    // ImageSwiper
  },
}
</script>
